// extracted by mini-css-extract-plugin
export default {"fondo":"encabezado_fondo__TL1zp"};